var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-tabs",
        {
          on: { "tab-click": _vm.handleClickTab },
          model: {
            value: _vm.tabsName,
            callback: function ($$v) {
              _vm.tabsName = $$v
            },
            expression: "tabsName",
          },
        },
        _vm._l(_vm.tabsConfig, function (tab) {
          return _c(
            "el-tab-pane",
            { key: tab.name, attrs: { label: tab.label, name: tab.name } },
            [
              tab.tips
                ? _c("div", { staticClass: "tips" }, [
                    _c("i", { staticClass: "el-icon-info icon" }),
                    _c("span", [_vm._v(_vm._s(tab.tips))]),
                  ])
                : _vm._e(),
            ]
          )
        }),
        1
      ),
      _c(
        "keep-alive",
        [
          _vm.tabsName === "2"
            ? _c("provinceDetailStatistics", {
                ref: "provinceDetailStatistics",
                staticStyle: { "margin-top": "10px" },
                attrs: {
                  entry: _vm.entry,
                  "order-id":
                    (_vm.originParams && _vm.originParams.order_id) || "",
                  "category-id":
                    (_vm.originParams && _vm.originParams.category_id) || "",
                  "order-type":
                    (_vm.originParams && _vm.originParams.type) || "",
                },
                on: { "jump-city": _vm.onJumpCityStatistics },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "keep-alive",
        [
          _vm.tabsName === "1"
            ? _c("cityDetailStatistics", {
                ref: "cityDetailStatistics",
                staticStyle: { "margin-top": "10px" },
                attrs: {
                  entry: _vm.entry,
                  "order-id":
                    (_vm.originParams && _vm.originParams.order_id) || "",
                  "category-id":
                    (_vm.originParams && _vm.originParams.category_id) || "",
                  "order-type":
                    (_vm.originParams && _vm.originParams.type) || "",
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }